// extracted by mini-css-extract-plugin
export default {"formWrapper":"Form_formWrapper__Pjbju"};